module.exports = __webpack_public_path__ + "static/media/HakinCodes.564769e7.jfif";